<template>
    <div class="pd video-tree">
        <el-form  :model="formData" :rules="formRules" ref="formRef" label-width="80px" size="mini">
            <el-form-item class="form-title"  label="素材类型" >
                <el-radio class="mrl15 mrt5"  v-model="formData.i_type" :label=2 @change="radiodata" >图片</el-radio>
                <el-radio class=" mrt5"  v-model="formData.i_type" :label=1 @change="radiodata" >视频</el-radio>
                <!--                <el-radio class="mrl15 mrt5"  v-model="radio" @change="radiodata" label="3" :disabled="addedit">链接</el-radio>-->
            </el-form-item>
            <el-form-item class="form-title proItem_info1" prop="imgList" label="内容">
                <div class="img-box">
                    <div class="uploadPhone flex fl-wr" >
                        <div class="flex" >
                            <div style="height: 100px;width: 100px" v-model="formData.vc_content">
                                <input type="file" name="files" value="" id="uploadfile1"
                                       class="upload-input uploadfile1" @change="upload">
                                <img src="@/assets/custom_pic.png" style="height:100% ;width: 80%" v-if="this.formData.vc_content.length==0">
                                <img :src="formData.vc_content" style="height:100% ;width: 80%" v-if="this.formData.vc_content.length!=0&&this.formData.i_type==2">
                                <video :src="formData.vc_content" style="height:100% ;width: 80%" controls="controls" v-if="this.formData.vc_content.length!=0&&this.formData.i_type==1"></video>
                            </div>
                        </div>
                        <!--<ul v-if="imgList.length>0" class="flex">
                            <li v-for="(oneimg,index) in imgList" :key="oneimg.i_fileid"
                                class="li-img mrr2" >
                                <img :src="oneimg.vc_path">
                                <i class="el-icon-delete" @click="removeli(oneimg,index)" ></i>
                            </li>
                        </ul>
                        <div class="upload-box flex1" v-model="formData.imgList">
                            <input type="file" name="files" value="" id="uploadfile1"
                                   class="upload-input uploadfile1" @change="upload" >
                            <img src="@/assets/custom_pic.png">
                        </div>-->
                    </div>
                </div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_note" label="说明" >
                <el-input  v-model="formData.vc_introducion" placeholder="请输入" style="width:90%">
                </el-input>
            </el-form-item>
        </el-form>
        <div slot="footer"  class="dialog-footer" style="text-align: center">
            <el-button type="primary" @click="saveForm" :class="baseerp+'btn'" :disabled="savedata" size="mini">保存</el-button>
            <el-button size="mini" @click="cancel">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import * as API from "../api"
    import {baseerp} from "@/utils/baseUrl";
    import {file_root} from "@/utils/baseUrl";
    import Video from "../index";
    export default {
        name: "uploadMaterial",
        components: {Video},
        props:{
            application:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                savedata:false,
                resourceList:[],
                pic_title:"选择素材",
                pic:{},
                pic_dialogVisible:false,
                scheduleId:"",
                showid:0,
                //isloop:"",
                srcsrc:"",
                inputdialogVisible:false,
                imputval:"",
                srcData:[],
                newarr:[],
                deleteLi: "",
                deleteLidex: "",
                imgList:[],
                videoList:[],
                equipment:{},
                dialogVisible:false,
                title:"",
                addedit:false,
                //shownum:'',
                i_type:"2",
                loop:1,
                draw:0,
                baseerp:"",
                /*********************************/
                edit:false,
                proname:"",
                formData:{
                    i_type:"2",
                    //loop:1,
                    //draw:0,
                    ///////////////imgList:[],
                    //videoList:[],
                    //gsname:"",
                    //cjname:"",
                    //zdname:"",
                    //proname:"",
                    //ckname:"",
                    //begintime:"",
                    //endtime:"",
                    //shul:0,
                    //num:"000000",
                    vc_content:"",
                    vc_introducion:"",
                    //vc_lruname: sessionStorage.getItem("lruname"),
                    //date:"",
                    //explain:"",
                },
                formRules:{
                    /*gsname:[{required:true,message:"请选择公司",trigger:"change"}],
                    cjname:[{required:true,message:"请选择车间",trigger:"change"}],
                    zdname:[{required:true,message:"请选择制定人",trigger:"change"}],
                    proname:[{required:true,message:"请选择产品",trigger:"change"}],
                    ckname:[{required:true,message:"请选择仓库",trigger:"change"}],
                    jgcost:[{required:true,message:"请输入加工费",trigger:"blur"}],
                    shul:[{required:true,message:"请输入数量",trigger:"blur"}],
                    endtime:[{required:true,message:"请选择结束日期",trigger:"change"}],
                    begintime:[{required:true,message:"请选择开始日期",trigger:"change"}],*/
                },
                companyName:[],
                groupName:[],
                personName:[],
                proList:[],
                warehouseName:[],
                gsid:0,
                ckid:0,
                pzid:0,
                cjid:0,
                i_id:0,
                i_type:9,
                wtgsid:0,
                zduid:0,
                zdname:"",
                pzname:"",
                wtname:"",
                gsname:"",
                cjname:"",
                lastTime:"",
                disabled:false,
                mid:0,
            }
        },
        watch:{

        },
        mounted() {
            this.baseerp=baseerp;
            //console.log("baseerp",this.baseerp);
            if (this.application){
                //console.log("从列表带到弹窗",this.application);
                this.formData.i_type=this.application.i_type

            }
        },
        computed:{
            /*//禁止跨月
            pickerOptions(){
                let _this = this
                return {
                    disabledDate(time) {
                        let start = new Date(_this.lastTime);
                        start.setDate(start.getDate());
                        return time.getTime() > start.getTime();
                    }
                }
            }*/
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),

            savesrc(){
                //console.log(this.srcsrc,"this.srcsrc");
                let obj={};
                obj.vc_path=this.srcsrc;
                this.imgList.push(obj);
                this.formData.imgList=this.imgList;
                //console.log(this.formData,"this.formData");
                this.inputdialogVisible=false;

            },

            quxiao(){
                //console.log(this.srcsrc,"this.srcsrc");
                this.inputdialogVisible=false;
            },

            choosepic(){
                this.pic.i_type=this.formData.i_type;
                this.pic_dialogVisible=true;
            },

            inputsrc(){
                this.srcsrc="";
                this.inputdialogVisible=true;
            },

            popShow(val){
                this.imputval=val;
                this.srcData.push('');
            },


            getvalue(val){
                //console.log(val,"val");
                this.videoList=val;
                this.equipment.select=this.videoList;
                //console.log(this.equipment,"this.equipment");
            },

            getpicvalue(val){
                //console.log(val,"val");
                this.pic.select=val;
                this.imgList=val;
                this.formData.imgList=this.imgList;
                //console.log(this.imgList,"imglist");
                //console.log(this.formData,"this.formData");
                /*for (var i=0;i<val.length;i++){
                    let map={};
                    map.vc_path=val[i].vc_path;
                    this.imgList.push(map);
                    this.formData.imgList=this.imgList;
                }
                this.pic.select=val;


                let arr=this.formData.imgList;
                let hash = {};
                arr = arr.reduce(function(item, next) {
                    hash[next.vc_path] ? '' : hash[next.vc_path] = true && item.push(next);
                    return item
                }, []);
                this.imgList=arr;
                this.formData.imgList=arr;
                console.log(this.formData,"this.formData",this.pic);*/
            },

            //删除li
            removeli(oneimg, index) {
                //console.log(oneimg, index, "oneimg")
                this.deleteLi = oneimg.i_fileid;
                this.deleteLidex = index;
                this.deletefile();
            },
            //li删除接口
            async deletefile() {
                this.imgList.splice(this.deleteLidex, 1);
                /*let param = {
                    i_id: this.deleteLi,
                };
                let res = await API.deleteFileInfo(param);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.imgList.splice(this.deleteLidex, 1);
                    //console.log(this.imgList, "newlist");
                    this.newarr = this.imgList;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }*/
            },

            pic_cancelDialog(){
                this.pic_dialogVisible=false;
            },

            cancelDialog(){
                this.dialogVisible=false;
            },

            videochange(){
                this.title="选择放映电视";
                this.dialogVisible=true;

            },

            radiodata(val){
                //console.log(val,"val");
                this.formData.i_type=val;
                this.formData.vc_content="";
            },

            loopdata(val){
                this.formData.loop=val;
            },

            drawdata(val){
                this.formData.draw=val;
            },



            async saveForm(){
                this.savedata=true;
                //console.log(this.formData,"formData");
                this.resourceList.push(this.formData) ;
                let param={
                    resourceList:this.resourceList,
                };
                //console.log("param",param);
                let res=await API.addResource(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.savedata=false;
                    this.$emit("close");
                    this.$emit("getResourceList");
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },

            taskList(data){
                // console.log("data",data);
                let val={
                    i_itype:this.i_type,
                    expanded: true,
                    data:data,
                }
                this.$emit('proDetails',val);
            },


            cancel(){
                this.$emit('close');
            },

            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.formData.date=`${date.getFullYear()}-${month}-${strDate}`;
                //console.log(this.formData.date)
            },
            //得到最后一天
            getLastDay(val){
                let date=new Date(this.formData.begintime);
                date.setDate(28);
                date.setMonth(date.getMonth()+1);
                let lastDay=date.setDate(0);
                let allDay= new Date(lastDay).toString();
                const lastdate = new Date(allDay);
                const month = (lastdate.getMonth() + 1).toString().padStart(2, '0');
                const strDate = lastdate.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.lastTime=`${lastdate.getFullYear()}-${month}-${strDate}`;
                this.$set(this.formData, "endtime",this.lastTime)
                // console.log( value)
            },

            //上传附件
            async upload(value) {
                this.imputval=1;
                //console.log(this.commitId, "thie.commitId")
                //console.log(value, "vaaaaaaaaaaaaaaa")
                let that = this;
                let i = 0;
                let $files = value.target.files[0];
                let fileName = $files.name;
                let type = $files.type;
                var list = {
                    "image/jpeg": true,
                    "image/png": true,
                    "image/jpg": true,
                    "image/bmp": true,
                    "application/pdf": true
                };
                let result = list[type];
                // if(($files && result==false) || ($files &&result==undefined)){
                //     that.$message.error('请上传格式正确的文件');
                //     return;
                // };
                if ($files) {
                    that.fileName = $files.name;
                    that.fileType = $files.type;
                    that.fileUrl = window.URL.createObjectURL(value.target.files[0]);
                } else {
                    that.fileName = "";
                    that.fileType = "";
                    that.fileUrl = "";
                }
                if (that.fileName) {
                    var fileId = 'uploadfile' + that.idNum;
                    var param = {
                        "file": fileId,
                        "fileName": that.fileName,
                        "IDtype": "",
                        "type": 1,
                        "style": "video",
                        "files": $files,
                        //"token":sessionStorage.getItem("token"),
                        //"app": "dsmanage",
                        "vc_app": "video",
                        "i_appid":0,
                        "version": "1.0",
                        "i_uid": sessionStorage.getItem("userid"),
                        //"vc_lruname": this.form.vc_lruname,
                        //"i_lruid": this.form.i_lruid,
                        "i_mid": this.mid
                    };
                    /*let abc = {
                        i_mid: this.mid,
                        style:"deliver",
                        vc_app:"deliver",
                        i_appid:this.commitId,
                        vc_lruname:this.form.vc_lruname,
                        i_lruid:this.form.i_lruid,
                    };*/
                    let FD = new FormData();
                    for (let key in param) {
                        FD.append(key, param[key])
                    }
                    // let res = await  fetch(upload,{
                    //     method:"post",
                    //     body:FD
                    // }).then(res=>res.text());
                    let res = await API.upload(param);
                    if (res.code == 1) {
                        //res =JSON.parse(res);
                        let data = res.data[0];
                        var imgPath = {};
                        imgPath.i_fileid = data.i_id;
                        //imgPath.vc_name = data.filename;
                        imgPath.vc_path = file_root+data.vc_path;
                        //imgPath.base64 = data.base64String;
                        //imgPath.filePath = data.i_id;
                        //imgPath.fileSort = that.didNum;
                        //imgPath.fileType = 1;
                        //imgPath.filenewname = data.filenewname;
                        that.imgList.push(imgPath);
                        that.didNum++;
                        that.idNum = that.didNum;
                        that.imgLength = that.imgList.length - 1;
                //        that.formData.imgList = that.imgList;
                        //console.log(that.imgList,"that.imgList11111111111");
                        that.formData.vc_content = file_root+data.vc_path;
                        //that.srcData=that.imgList;
                        //that.Data=[...that.srcData];
                        //console.log(data, that.imgList, that.formData.imgList, "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx")
                        //this.removeli();
                        //console.log(that.imgList, "newlist")
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        that.$message.error(res.message);
                    }
                }
            },
        },
    }
</script>

<style lang="scss" scoped>

    .mrr2{
        margin-right: 2px;
    }

    .flex- {
        display: flex;
        flex-flow: wrap;
        justify-content: flex-start;
        align-items: center;
    }



    .mrr15{
        margin-right: 15px;
    }

    /***********************************/
    .pd{
        min-width: 500px;
    }
    .flex{
        display: flex;
    }
    .item{
        width: 100%;
    }





    /deep/{
        .ghwdiv .el-dialog__header{
            background-color: #3e82e8;
        }


        .havaydiv .el-dialog__header{
            background-color: #e8c984;
        }

        .el-dialog__body{
            word-break:unset;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
        .page {
            padding: 6px;
        }
        .el-tabs--border-card > .el-tabs__content{
            height: calc(100% - 60px);
            overflow-y: auto;

        }
    }

    /deep/{

        .input .el-input__inner{
            width: 200px;
        }

        .num{
            margin-bottom: 12px;
        }
        .num .el-form-item__label {
            color: #b3d268;
            font-size: 16px;
            font-style: italic;
        }
        .num .el-form-item__content {
            width: 130px;
        }
        /* .el-table td,.el-table td, .el-table th {
             padding: 8px 0;
         }*/
        .danger-row{
            color: #999;
        }

    }

    /*@media screen and (max-height: 770px) {
        .video-tree {
            //width: 420px;
            height: 600px;
        }
    }
    @media screen and (min-height: 900px) {
        .video-tree {
            //width: 530px;
            height: 600px;
        }
    }
    @media screen and (min-height: 780px) and (max-height: 830px) {
        .video-tree {
            //width: 450px;
            height: 600px;
        }
    }

    //实现滚动功能
    .video-tree {
        overflow-y: auto;
    }*/
    .proItem_info1{
        text-align: left;
        .one-title{
            width: 100px;
            display: inline-block;
            text-align: center;
        }
        /deep/{
            .el-icon-star-on{
                display: inline-block;
                vertical-align:super;
            }

        }
        .zs{
            padding-left: 16px;
            color: #a0a0a0;
        }
        .img-box{
            /*border: 1px solid red;*/
            margin: 10px;
            .uploadPhone{
                width: 70px;
                height: 80px;
                position: relative;
                width: 100%;
                /*border: 1px solid cornflowerblue;*/
            }
            .uploadPhone img{
                width: 70px;
                height: 80px;
            }
            .upload-box{
                /*background: red;*/
                width: 10%;
                height: 100%;
            }
            .upload-input{
                position: absolute;
                opacity: 0;
                width: 100px;
                height: 105px;
            }
        }
        .flex1{
            display: flex;
        }
    }
</style>